import { render, staticRenderFns } from "./index-event.vue?vue&type=template&id=3bd2ed32&"
import script from "./index-event.vue?vue&type=script&lang=js&"
export * from "./index-event.vue?vue&type=script&lang=js&"
import style0 from "./index-event.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports